<template>
  <div
    id="signup"
    class="d-flex flex-column justify-center"
  >
    <v-scroll-y-transition>
      <v-window 
        v-if="stepReady"
        v-model="current.index"
        touchless
        class="steps"
        @change="onStepChange"
      >
        <v-window-item 
          v-for="(step, i) in flow"
          :key="'step-'+i"
          class="step"
          :value="i"
        >
          <v-sheet
            class="sheet d-flex flex-column justify-space-between flex-grow-1 text-center"
          >
            <v-card-text class="scrollable pa-8">
              <img 
                :src="require(`@/assets/step-icon-${setIcon}.svg`)"
                class="step-icon mb-4"
              >
              <h5 v-if="step.index>0" class="overline secondary--text my-2">
                {{ $t('signup.step', { i }) }}
              </h5>
              <h4 class="step-title text-h6 my-4">
                {{ $t(step.title) }}
              </h4>
              <p class="text text-body-1 mt-6 mb-8" v-html="formatText($t(step.subtitle))" />
              <component 
                :is="step.component"
                :ref="'step'+i"
                :step="step"
                :hive="hive"
                :device="device"
                :appURL="appURL"
                :help-content="helpContent"
                :refresh="refresh"
                @update="onStepUpdate"
                @next="onNext"
              >
                <!-- <template v-slot:quick-access>
                  <v-card 
                    v-if="panels.length>0"
                    outlined
                    color="transparent"
                    class="quick-access-card text-left mx-n4 my-8"
                  >
                    <v-card-text
                      class="mb-n8"
                    >
                      <h2 
                        class="text-h6 primary--text mb-4"
                      >
                        <v-icon 
                          color="primary"
                          class="mr-4"
                        >
                          {{ icons.benefits }}
                        </v-icon>
                        Clube Mobees
                      </h2>
                      <p class="text-body-2">
                        A Mobees, em parceria com outras empresas, oferece benefícios exclusivos para nossos motoristas. Aproveite!
                      </p>
                    </v-card-text>
                    <quick-access 
                      :data="panels"
                      headless
                      center
                      max-width="calc(100vw - 32px)"
                      background="transparent"
                      class="quick-access mb-n4"
                      @toggle-help="toggleHelp"
                    />
                  </v-card>
                </template> -->
              </component>
            </v-card-text>
          </v-sheet>
        </v-window-item>
      </v-window>
    </v-scroll-y-transition>

    <v-card-actions 
      v-show="step.cta.toggle && !benefits.toggle"
      class="step-cta pt-4 px-4"
    >
      <v-btn 
        large
        block
        color="accent"
        class="btn-cta grey--text text--darken-4"
        @click="action('step'+current.index)"
      >
        {{ $t(step.cta.text) }}
      </v-btn>
    </v-card-actions>

    <v-bottom-sheet
      v-model="referral.toggle"
    >
      <v-card
        color="black"
        class="safe-bottom text-center pb-0 pt-12 rounded-xl"
        v-touch="{ down: () => { toggleReferral(false) } }"
      >
        <v-card-text>
          <!-- <v-icon 
            size="40"
            color="primary"
          >
            {{ icons.referral }}
          </v-icon> -->
          <div class="icon text-h3">
            <icon-base
              width="37"
              height="43"
              name="hive"
              color="primary"
              class="hive w-25"
            >
              <brand-symbol />
            </icon-base>
          </div>
          <h2 
            class="text-h5 font-weight-bold primary--text my-8"
            v-html="formatText($t('referrals.cta.title'))"
          />
          <p 
            class="text-body-1" 
            v-html="formatText($t('referrals.cta.text'))"
          />

          <v-btn
            block
            large
            color="primary"
            class="black--text my-8"
            @click="copyReferralURL({ profile })"
          >
            {{ $t('referrals.cta.button') }}
          </v-btn>
          
          <v-btn
            text
            small
            color="grey"
            @click="toggleReferral(false)"
          >
            {{ $t('referrals.cta.no_thanks') }}
          </v-btn>
        </v-card-text>

      </v-card>
    </v-bottom-sheet>

    <!-- <v-bottom-sheet
      v-model="benefits.toggle"
    >
      <v-card
        color="grey darken-4"
        class="text-center py-8"
      >
        <v-card-text
          class="mb-n8"
        >
          <v-icon 
            size="40"
            color="primary"
          >
            {{ icons.benefits }}
          </v-icon>

          <h2 
            class="text-h6 primary--text my-4"
          >
            Clube Mobees
          </h2>
          <p class="text-body-2">
            A Mobees, em parceria com outras empresas, oferece benefícios exclusivos para nossos motoristas. Aproveite!
          </p>
        </v-card-text>
        
        <m-alerts 
          :data="panels"
          headless
          center
          background="transparent"
          @toggle-help="toggleHelp"
        />

        <v-btn
          text
          small
          color="grey"
          @click="benefits.toggle=false;"
        >
          Não, obrigado
        </v-btn>

      </v-card>
    </v-bottom-sheet> -->


    <onboarding />

    <profile 
      ref="profile"
      :toggle="view.profile.toggle"
      :super-status="superStatus"
      @load="onLoadProfile"
      @step-update="onUpdateProfile"
      @action="action"
    />

    <help 
      v-if="helpContent!=null"
      :toggle="view.help.toggle"
      :content="helpContent"
      :hive="hive"
    />

    <terms-of-service />

    <privacy-policy />

    <toast />

    <v-overlay 
      :value="!ready || !stepReady"
      color="grey darken-4"
      fixed
      opacity="1"
      z-index="3"
      class="loading-overlay text-center"
    >
      <loading 
        class="loading mb-6" 
      />
      <span class="d-block text-overline grey--text text--darken-1">
        {{ $t('general.loading') }}
      </span>
    </v-overlay>
  </div>
</template>

<style>

  #signup {
    position: relative;
    padding: 0;
    width: 100%;
  }
  #main {
    background: var(--v-background-base) !important;
  }
  /* @media (min-width: 600px) and (orientation: landscape) {
    #signup {
      width: 360px;
      max-height: 640px;
      margin: 4rem auto;
      border-radius: 1rem;
      border: 1px solid var(--v-secondary-darken2);
    }
  } */

  /* #signup .sheet.scrolls {
    max-height: calc(100vh - 56px);
  } */

  #signup .step .overline {
    font-size: .75rem !important;
  }
  #signup .step .step-icon {
    height: 25vw;
  }
  #signup .step .step-title {
    font-size: 1.5rem !important;
  }
  #signup .step .quick-access-card {
    max-width: initial;
    border-color: var(--v-secondary-darken2) !important;
  }

  .hive {
    height: 48px;
  }

  .step-cta {
    position: sticky;
    bottom: 0;
    padding-bottom: calc(var(--safe-area-bottom) + 16px) !important;
    backdrop-filter: blur(4px);
  }

  .safe-bottom {
    padding-bottom: var(--safe-area-bottom) !important;
  }

  .loading-overlay .loading {
    width: 56px;
    height: 56px;
    opacity: 1;
  }
  

</style>

<script>

  // Icons
  import {
    mdiSale,
    mdiShareVariantOutline
  } from '@mdi/js'

  // Utilities
  import services from '@/services.js'
  import { steps } from '@/services/signup'
  import { defaults as profileDefaults } from '@/services/profile.js'

  import { sync, get } from 'vuex-pathify'
  import device from '@/device';

  export default {
    name: 'Signup',

    props: {
      active: {
        type: Boolean,
        default: true
      },
      installed: {
        type: Boolean,
        default: false
      },
      modal: {
        type: String,
        default: null
      },
      dev: {
        type: Boolean,
        default: false
      },
      ready: {
        type: Boolean,
        default: false
      }
    },

    data: () => ({
      api: process.env.VUE_APP_ROOT_API,
      icons: {
        benefits: mdiSale,
        referral: mdiShareVariantOutline
      },
      current: {
        index: 0,
        key: null,
      },
      steps: _.mapValues(steps, (step, key) => {
        step.key = key;
        if (!step.component) step.component = 'step'+step.index+(step.hasOwnProperty('suffix') ? step.suffix : '');
        return step;
      }),
      benefits: {
        toggle: false,
        opened: false,
        headless: true
      },
      view: {
        help: {
          toggle: false,
        },
        profile: {
          toggle: false,
        },
      },
      referral: {
        toggle: false,
        timestamp: null
      },
      onboarding: null,
      show: false,
      profileLoaded: false,
      updated: false,
      updatedAt: null,
      device: device,
      refresh: false,
      helpContent: null,
      appURL: process.env.VUE_APP_ROOT
    }),

    computed: {
      // steps: get('signup/steps'),
      // current: sync('signup/current'),
      config: sync('app/config'),
      views: sync('app/views'),
      help: sync('app/views@help'),
      tickets: sync('app/views@help.tickets'),
      username: sync('user/username'),
      profile: sync('user/profile'),
      status: sync('user/status'),
      auth: sync('user/auth'),
      express: sync('user/express'),
      toast: sync('app/toast'),
      version: sync('app/version'),

      flow () {
        const steps = _.cloneDeep(this.steps);
        const isOwner = this.isOwner;
        const express = this.express;
        return _.orderBy(_.pickBy(steps, step => {
          const scope = _.isString(step.status) ? [step.status] : step.status;
          return step.status==null || (express===step.express||(_.isNil(step.express) && !(isOwner && scope.includes('SIG'))));
        }), ['index', 'suffix'], ['asc', 'asc']);
      },

      step () {
        const flow = this.flow;
        const current = this.current;
        const step = flow[current.index];
        // Return step with default cta if it doesn't exist
        return step ? {
          ...step,
          cta: step.cta || { toggle: false, text: '' }
        } : { cta: { toggle: false, text: '' } };
      },

      superStatus () {
        const current = this.current;
        const step = this.flow[current.index];
        return step.key;
      },

      setIcon () {
        const flow = this.flow;
        const current = this.current;
        const icon = this.stepReady && current.index>0 && current.index in flow ? flow[current.index].icon : 'loading';
        return _.isString(icon) ? icon : icon[current.key];
      },

      isOwner () {
        const isOwner = this.profile.vehicle.isOwner;
        return isOwner===null || isOwner==1;
      },  

      // stepReady () {
      //   const current = this.current;
      //   return current.key=='ENR' ? this.isOwner!==null : this.show;
      // },

      stepReady () {
        const current = this.current;
        const updated = this.updated;
        const profileLoaded = this.profileLoaded;
        console.log('stepReady', current.key, updated, profileLoaded);
        return updated && profileLoaded;
      },

      panels () {
        let panels = [];
        const sections = this.helpContent;
        const status = this.status;
        const benefits = _.has(sections, 'benefits') ? _.clone(sections['benefits']) : null;
        if (!!benefits) {
          const full = _.has(benefits, 'full') && _.indexOf(benefits.full, status)>=0;
          benefits.full = full;
          if (!full) {
            benefits.content = { 
              available: _.map(_.filter(sections['benefits'].cards, benefit => {
                const section = sections[benefit.key];
                const isTarget = (!_.has(section, 'targetStatus')||_.indexOf(section.targetStatus, status)>=0);
                const isValid = (!_.has(section, 'startsAt')||this.$moment().isAfter(section.startsAt))&&(!_.has(section, 'expiresAt')||this.$moment().isBefore(section.expiresAt));
                return isTarget&&isValid;
              }), benefit => {
                const section = sections[benefit.key];
                const activated = !_.isNil(_.find(this.tickets, ticket => {
                  let activated = false;
                  if (ticket.section==benefit.key) {
                    activated = !ticket.closed||_.has(section, 'props')&&_.has(section.props, 'multiple')&&!section.props.multiple;
                  }
                  return activated;
                }));
                return { ...benefit, activated }
              }),
              expired: []
            }
          }

          if (!_.isEmpty(benefits.content.available)) {
            panels.push({
              issue: 'benefits',
              type: 'benefits',
              view: 'help',
              priority: 31,
              title: this.$t('club.title'),
              text: '',
              color: 'transparent',
              data: benefits
            })
          }
        }
        return panels;
      },

      hive () {
        const profile = this.profile;
        const hive = _.isNil(profile.hive) ? profileDefaults.hive : profile.hive;
        const uri = 'geo:0,0?q=' + _.replace(_.join([hive.address, hive.city], ', '), ' ', '+');
        return {
          ...hive,
          uri
        }
      },
    },

    watch: {
      $route: {
        // immediate: true,
        handler ($route) {
          if (_.has($route.params, 'step')) {
            const key = $route.params.step;
            this.setStep(key);
          }
        }
      },
      active: {
        immediate: true,
        handler (active) {
          if (this.ready) this.visibilityChange(active);
        }
      },
      ready: {
        immediate: true,
        handler (ready) {
          if (ready) {
            this.initSignup();
            this.visibilityChange(this.active);
          }
        }
      },
      panels (panels) {
        // if (this.panels.length>0&&this.onboarding=='opened') {
        //   if (_.indexOf(['FDB','REA'], this.status)>=0&&!this.benefits.opened&&!_.every(this.panels[0].data.content.available, ['activated', true])) {
        //     this.benefits.toggle = true;
        //     this.benefits.opened = true;
        //   }
        // }
      },
      modal: {
        immediate: true,
        handler (view) {
          if (!!view&&_.has(this.view, view)) {
            // open view
            if (view=='help') {
              const route = this.$route;
              this.view.help.section = route.query.section;
              this.view.help.context = route.name;
            }
            this.view[view].toggle = true;
          }else{
            _.each(this.view, view => {
              if (_.has(view, 'toggle')&&view.toggle) view.toggle = false;
            })
          }
        }
      },
      helpContent: {
        immediate: true,
        deep: true,
        handler (content) {
          if (!!content&&_.has(content.controller, 'maintenance')&&content.controller.maintenance) {
            this.$router.replace({ path: '/maintenance' });
          }
        }
      }
    },

    methods: {
      ...services,

      action (step) {
        // console.log(step);
        this.$refs[step][0].actionCalled();
      },

      toggleReferral (b) {
        console.log('referral', b);
        this.referral.toggle = b;
      },

      onStepChange (step) {
        console.log('step changed -> ', step);
      },

      goToStep (status) {
        const key = status=='DOC' && this.isOwner ? 'SIG' : status=='FDD' ? 'ENR' : status;
        const current = _.has(this.$route.params, 'step') ? this.$route.params.step : null;
        if (current!=key) {
          this.$router.replace('/signup/'+key);
        }else{
          this.setStep(key);
        }
      },

      setStep (key) {
        const flow = this.flow;
        this.current.index = !!key ? _.findIndex(flow, step => {
          const scope = _.isString(step.status) ? [step.status] : step.status;
          return !!scope && scope.includes(key);
        }) : 0;
        this.current.key = key;
      },

      onNext (data) {
        const { status, info=null } = data;
        const step = this.steps[status];
        if (!!info) this.steps[status] = { ...step, ...info };
        this.goToStep(status);
      },

      onStepUpdate (data) {
        const current = this.current;
        // console.log('step updated -> ', data);
        const step = this.flow[current.index];
        if (!!data) this.steps[step.key] = { ...step, ...data };
      },

      onUpdateProfile (data) {
        this.onStepUpdate(data);
      },

      onLoadProfile (profile) {
        this.goToStep(this.status);
        this.profileLoaded = true;
      },

      getStatus (username) {
        console.log('checking username status...');
        username = this.rawUsername(username);
        if (username !== this.username) this.username = username;

        this.$api
          .get('/driver/status/?username='+username)
          .then(response => {
            console.log('getStatus => ',response);
            if(response.data.retorno==200){
              // Store username status
              const status = response.data.status;
              if (['ACT', 'EXP'].includes(status)) {
                this.$router.push('/main');
              }else{
                this.goToStep(status);
              }
              this.status = status; 
              this.statusChange = response.data.dt_Status;
              this.express = response.data.express || false;
              this.updatedAt = this.$moment().valueOf();
              if (!this.updated) {
                this.updated = true;
              }else{
                this.refresh = true;
              }

            }
          })
          .catch(error => {
            this.handleError(error);
            if (this.status==null) {
              this.getout();
            }else{
              // setTimeout(($) => {
              //   $.getStatus();
              // }, 7000, this);
            }
          })
          .finally(() => {
          });
      },

      getNotifications () {
        this.views.notifications.loading = true;

        this.$api
          .get('/driver/notifications')
          .then(response => {
            console.log('getNotifications => ', response);
            if(response.data.retorno!=400){
              const notifications = _.mapValues(_.keyBy(response.data.notifications, 'id'), notification => {
                return {
                  ...notification,
                  sent: this.$moment.utc(notification.sent).local().format('YYYY-MM-DD HH:mm:ss')
                }
              });
              this.views.notifications.items = Object.assign({}, notifications);
              this.views.notifications.updatedAt = this.$moment().valueOf();
              this.views.notifications.loading = false;
            }else{
              // this.toggleToast(
              //   true,
              //   'Erro ao carregar notificações',
              //   5000,
              //   false,
              // );
            }
          })
          .catch(error => {
            setTimeout(($) => {
              $.getNotifications();
            }, 7000, this);
            this.handleError(error, false);
          })
          .finally(() => {
          });
      },

      getProfile () {
        const $ = this;
        if (_.has($.$refs, 'profile')) {
          $.$refs['profile'].getProfile(async () => {
            // check if help content has referrals and is not null
            const referrals = $.helpContent?.referrals;
            if (!!referrals) {
              $.$nextTick(async () => {
                const referralDisplay = await $.getStorage('referralDisplay');
                if ((_.isNil(referralDisplay)&&$.$moment().subtract(1, 'day').isAfter($.statusChange))||$.$moment().subtract(1, 'week').isAfter(parseInt(referralDisplay))) {
                  // show display again
                  $.toggleReferral(true);
                  $.setStorage('referralDisplay', Date.now());
                }
              });
            }
          });
        }else{
          setTimeout(() => {
            $.getProfile();
          }, 500, $);
        }
      },

      initSignup () {
        if (this._signupInit) return;
        this._signupInit = true;

        if (this.status=='DEN') {
          this.getout();
        } else {
          this.getStatus(this.username);
          this.getNotifications();
          this.getProfile();
          setTimeout(vue => vue.show = true, 1000, this);
        }

        this.loadHelpContent(false);
      },

      onRefresh () {
        this.refresh = false;
      },

      visibilityChange (active) {
        if (!this.ready) return;
        // check status
        if (active&&(this.updatedAt==null||this.$moment().diff(this.updatedAt, 'minutes')>5)) {
          this.getStatus(this.username);
          this.getNotifications();
          if (_.has(this.$refs, 'profile')) this.$refs['profile'].getProfile();
          const step = 'step'+this.current.index;
          if (_.has(this.$refs, step)) this.$refs[step][0].updateView();
        }
      },
      // closeViews () {
      //   for(let view in this.views) {
      //     if (this.views[view].toggle) this.views[view].toggle = false;
      //   }
      // },
    },

    created () {
      
    },

    async mounted () {
      // set GA UserType dimension
      this.$gtag.customMap({ 'dimension1': 'UserType' });
      this.$gtag.set({
        'UserType': 'Candidato'
      });

      this.onboarding = localStorage.getItem("onboarding");

      this.cancelToasts();
    },

    components: {
      Step0: () => import('@/views/signup/Step0'),
      Step1: () => import('@/views/signup/Step1'),
      Step2: () => import('@/views/signup/Step2'),
      Step3A: () => import('@/views/signup/Step3A'),
      Step3B: () => import('@/views/signup/Step3B'),
      Step4: () => import('@/views/signup/Step4'),
      Step5: () => import('@/views/signup/Step5'),
      // mAlerts: () => import('@/components/mAlerts'),
      Onboarding: () => import('@/views/signup/Onboarding'),
      Profile: () => import('@/views/home/Profile'),
      Toast: () => import('@/components/Toast'),
      Help: () => import('@/views/help/Help'),
      TermsOfService: () => import('@/views/help/terms/Index'),
      PrivacyPolicy: () => import('@/views/help/privacy/Index'),
      Loading: () => import('@/components/IconLoading'),
    },
  }
</script>
